var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransportePatinete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M19.036 14.646l.194 1.549c-.9.376-1.535 1.265-1.535 2.3 0 1.375 1.118 2.494 2.492 2.494 1.375 0 2.493-1.119 2.493-2.493 0-1.252-.927-2.291-2.131-2.467L18.793 1.996C18.651.858 17.678 0 16.531 0h-1.996v1.33h1.996c.479 0 .884.357.943.831l1.353 10.814-3.175 3.176H6.93c-.844-1.59-2.516-2.676-4.438-2.676v1.33c2.035 0 3.691 1.655 3.691 3.69v.297H4.967c.012-.097.019-.196.019-.296 0-1.375-1.119-2.493-2.493-2.493C1.118 16.003 0 17.121 0 18.496c0 1.374 1.118 2.493 2.493 2.493.754 0 1.43-.337 1.888-.868h9.18l5.475-5.475z",
    transform: "translate(3 4.004)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportePatinete);
export default __webpack_public_path__ + "static/media/transporte-patinete.e9482961.svg";
export { ForwardRef as ReactComponent };